<footer class="footer">
    <div class="container text-center">
        <a class="cc-facebook btn btn-link" href="https://www.facebook.com/vamshi.rockzz.581/" target="_blank">
            <i class="fa fa-facebook fa-2x " aria-hidden="true"></i>
        </a>
        <a class="cc-instagram btn btn-link" href="https://www.instagram.com/iam_vamshi564/" target="_blank">
            <i class="fa fa-instagram fa-2x " aria-hidden="true"></i>
        </a>
        <a class="cc-twitter btn btn-link " href="https://twitter.com/IVamshi564" target="_blank">
            <i class="fa fa-twitter fa-2x " aria-hidden="true"></i>
        </a>
        <a class="cc-github btn btn-link " href="https://github.com/Vam564" target="_blank">
            <i class="fa fa-github fa-2x " aria-hidden="true"></i>
        </a>
    </div>
    <div class="text-center text-muted">
        <p>&copy; All rights reserved VK Global</p>
    </div>
</footer>